import * as React from 'react'
import { Redirect } from 'react-router-dom'
import { Datepicker } from '@mobiscroll/react'
import moment, { Moment } from 'moment'
import { milesToMeters, secondsToHours } from 'src/utils'
import UIMessages from 'src/utils/ui-messages'
import { IDriverAddSessionObject } from 'src/types/driver'
import Modal from '../ui/Modal'
import { Input, Select } from '@mobiscroll/react-latest'
import { withNotification } from '../ui/notification-provider'

export interface ISessionHistoryAddTimeModalProps {
  history: any
  match: any
  saveData: (request: IDriverAddSessionObject) => any
  operatorId: string
  toDate: string
  fromDate: string
  notification: any
}

interface ISessionHistoryAddTimeModalModalState {
  checkInCoordinates: string | undefined
  checkOutCoordinates: string | undefined
  clockIn: string
  clockInDisplay: string
  clockOut: string
  clockOutDisplay: string
  distanceTraveled: string | undefined
  error: string
  isModalOpen: boolean
  isSubmitting: boolean
  redirect: boolean
  sessionType: string
  timeDelta: string
}

interface ISelectOption {
  text: string
  value: string
}

const options: ISelectOption[] = [
  { text: 'Work Time', value: 'work_time' },
  { text: 'Standby', value: 'standby' },
  { text: 'After Hours', value: 'after_hours' },
  { text: 'Break', value: 'break' }
]

class SessionHistoryAddTimeModal extends React.Component<
  ISessionHistoryAddTimeModalProps,
  ISessionHistoryAddTimeModalModalState
> {
  constructor(props: ISessionHistoryAddTimeModalProps) {
    super(props)

    this.state = {
      checkInCoordinates: undefined,
      checkOutCoordinates: undefined,
      clockIn: moment(new Date().setSeconds(0, 0)).format(),
      clockInDisplay: moment(new Date().setSeconds(0, 0)).format('MM/DD/YYYY HH:mm'),
      clockOut: moment(new Date().setSeconds(0, 0)).format(),
      clockOutDisplay: moment(new Date().setSeconds(0, 0)).format('MM/DD/YYYY HH:mm'),
      distanceTraveled: undefined,
      error: '',
      isModalOpen: true,
      isSubmitting: false,
      redirect: false,
      sessionType: options[0].value,
      timeDelta: '00:00:00'
    }

    this.selectSessionType = this.selectSessionType.bind(this)
    this.handleChangeClock = this.handleChangeClock.bind(this)
    this.handleCheckInCoordinatesChanged = this.handleCheckInCoordinatesChanged.bind(this)
    this.handleCheckOutCoordinatesChanged = this.handleCheckOutCoordinatesChanged.bind(this)
    this.handleDistanceTraveledChanged = this.handleDistanceTraveledChanged.bind(this)
    this.handleCancelClick = this.handleCancelClick.bind(this)
    this.getTimeDelta = this.getTimeDelta.bind(this)
    this.saveData = this.saveData.bind(this)
  }

  public render() {
    const {
      checkInCoordinates,
      checkOutCoordinates,
      clockInDisplay,
      clockOutDisplay,
      distanceTraveled,
      isSubmitting,
      timeDelta
    } = this.state

    if (this.state.redirect === true || this.state.isModalOpen === false) {
      return <Redirect to={`/drivers/${this.props.operatorId}/session-history`} />
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>ADD TIME</span>
            <div
              style={{
                pointerEvents: this.state.isSubmitting ? 'none' : 'auto',
                opacity: this.state.isSubmitting ? 0.4 : 1.0
              }}
              className='mt1 border-top'
            >
              <div className='flex-wrap direction-row items-center col-12 mb-auto mt1 pt1'>
                <div className='dsh-session-type-wrapper flex flex-column'>
                  <Select
                    data={options}
                    touchUi={false}
                    value={this.state.sessionType}
                    onChange={({ value }) => this.selectSessionType(value)}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Session Type`}
                    labelStyle='floating'
                  />
                </div>
                <div className='dsh-clock-in-out-wrapper flex flex-column mt1'>
                  <Datepicker
                    controls={['calendar', 'time']}
                    dateFormat='MM/DD/YYYY'
                    placeholder='Clock In/Out'
                    inputProps={{
                      className: 'session-history-picker add-time'
                    }}
                    max={moment()}
                    rangeEndLabel='Out'
                    rangeStartLabel='In'
                    select='range'
                    timeFormat='HH:mm'
                    value={[moment(clockInDisplay), moment(clockOutDisplay)]}
                    onChange={({ value }) => this.handleChangeClock(value)}
                  />
                </div>
                <div className='mt1 ml1'>
                  <label className='h6'>Duration {timeDelta}</label>
                </div>
                <div className='mt1'>
                  <Input
                    className='mobiscroll-input'
                    name='coordinates'
                    placeholder={'Lat, Long'}
                    type='text'
                    value={checkInCoordinates}
                    onChange={this.handleCheckInCoordinatesChanged}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Check-in Coordinates`}
                    labelStyle='floating'
                  />
                </div>
                <div className='mt1'>
                  <Input
                    className='mobiscroll-input'
                    name='coordinates'
                    placeholder={'Lat, Long'}
                    type='text'
                    value={checkOutCoordinates}
                    onChange={this.handleCheckOutCoordinatesChanged}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Check-out Coordinates`}
                    labelStyle='floating'
                  />
                </div>
                <div className='mt1'>
                  <Input
                    className='mobiscroll-input'
                    name='distance'
                    placeholder={'Distance in miles'}
                    type='text'
                    value={distanceTraveled}
                    onChange={this.handleDistanceTraveledChanged}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`Distance Traveled`}
                    labelStyle='floating'
                  />
                </div>
              </div>
              <div className='flex justify-end mt2 w100'>
                <button
                  className='CancelButton custom-btn mbsc-clear-btn'
                  disabled={isSubmitting}
                  type='button'
                  onClick={this.handleCancelClick}
                >
                  {UIMessages.common.cancel}
                </button>
                <button
                  className='SubmitButton custom-btn mbsc-green-btn ml1'
                  disabled={isSubmitting}
                  type='button'
                  onClick={this.saveData}
                >
                  Save Time
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private selectSessionType = (value: string) => {
    this.setState({ sessionType: value })
  }

  private handleChangeClock = (value: Date[]) => {
    const [clockIn, clockOut] = value
    if (moment(clockIn).isValid() && moment(clockOut).isValid()) {
      const clockInDate = moment(clockIn)
      const clockOutDate = moment(clockOut)
      this.setState(
        {
          clockIn: clockInDate.format(),
          clockInDisplay: clockInDate.format('MM/DD/YYYY HH:mm')
        },
        () => {
          this.setState({
            clockOut: clockOutDate.format(),
            clockOutDisplay: clockOutDate.format('MM/DD/YYYY HH:mm'),
            timeDelta: this.getTimeDelta(clockInDate, clockOutDate)
          })
        }
      )
    }
  }

  private handleCheckInCoordinatesChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ checkInCoordinates: `${e.target.value}` })
  }

  private handleCheckOutCoordinatesChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ checkOutCoordinates: `${e.target.value}` })
  }

  private handleDistanceTraveledChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ distanceTraveled: `${e.target.value}` })
  }

  private handleCancelClick = () => {
    this.setState({ isModalOpen: false })
  }

  private getTimeDelta = (clockInDate: Moment, clockOutDate: Moment) => {
    const duration = moment.duration(clockOutDate.diff(clockInDate))
    const seconds = duration.asSeconds()
    return secondsToHours(seconds, true)
  }

  private saveData = async () => {
    const { fromDate, operatorId, toDate, saveData, notification } = this.props

    const {
      checkInCoordinates,
      checkOutCoordinates,
      clockIn: checkInTime,
      clockOut: checkOutTime,
      distanceTraveled,
      error,
      sessionType,
      timeDelta: duration
    } = this.state

    const session: IDriverAddSessionObject = {
      checkInCoordinates,
      checkOutCoordinates,
      checkInTime,
      checkOutTime,
      distanceTravel: Number(milesToMeters(Number(distanceTraveled))),
      duration,
      fromDate,
      operatorId,
      sessionType,
      toDate
    }

    if (error !== '' || !error) {
      const res = await saveData(session)
      this.setState({
        isSubmitting: true,
        redirect: true
      })

      if (!res || res.success === false) {
        notification.addNotification({
          title: res && res.message ? res.message : 'Session not saved. Check for overlapping time.',
          level: 'error'
        })
      } else {
        notification.addNotification({
          title: 'Successfully added time!',
          level: 'success'
        })
      }
    }
  }
}

export default withNotification(SessionHistoryAddTimeModal)



// WEBPACK FOOTER //
// ./src/components/drivers/SessionHistoryAddTimeModal.tsx